import React from 'react';
import styled from 'styled-components';
import Select from '../../../../components/Select/SelectFilter';
import { I18n } from 'react-redux-i18n';

const RecapFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  :not(:last-children) {
    margin-right: 45px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;

    > div {
      margin-right: 0 !important;
      margin-top: 20px;
    }
  }
`;

const RecapFilters = ({ selections, options, onChange }) => (
  <RecapFiltersContainer>
    <Select
      selectedOption={selections.wine}
      onChange={(selectedOption) => onChange('wine', selectedOption)}
      options={options.wine}
      label={I18n.t('primeur.recap.filters.wine')}
      containerStyles={`width:300px;  :not(:last-child){margin-right:45px}`}
    />
    <Select
      selectedOption={selections.vintage}
      onChange={(selectedOption) => onChange('vintage', selectedOption)}
      options={options.vintage}
      containerStyles={`width:300px; :not(:last-child){margin-right:45px}`}
      label={I18n.t('primeur.recap.filters.vintage')}
    />
  </RecapFiltersContainer>
);

export default RecapFilters;
